import { components } from "@/api-schema";

type Vehicle = components["schemas"]["Vehicle"];

export function vehicleHasOwningBranch(vehicle: Pick<Vehicle, "owningBranch">): boolean {
  return vehicle.owningBranch != null;
}
